/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const Stream = zod.object({
  "canRead": zod.boolean().optional(),
  "canWrite": zod.boolean().optional(),
  "canSeek": zod.boolean().optional(),
  "canTimeout": zod.boolean().optional(),
  "length": zod.number().optional(),
  "position": zod.number().optional(),
  "readTimeout": zod.number().optional(),
  "writeTimeout": zod.number().optional()
});

export type Stream = zod.input<typeof Stream>;
export type StreamOutput = zod.output<typeof Stream>;
